import { Link } from "@tanstack/react-router";
import { ToothIcon } from "@/components/tooth-icon";
import { cn } from "@/lib/utils";

/** The "mola" home link. The pixel tooth is decoration; the link's name stays "mola". */
export function Wordmark({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={cn(
        "flex items-center gap-2 font-semibold text-xl lowercase tracking-tight",
        className,
      )}
    >
      <ToothIcon className="size-6" />
      mola
    </Link>
  );
}
